import { IconDeviceMobile, IconLocation, IconPlus } from '@tabler/icons-react';
import React from 'react';
import "./Style.css";

const CardPreview = ({ pageData, blocksData }) => {

    return (
        <div className={`max-w-xl ms-auto h-[650px] rounded-xl border-2 overflow-hidden overflow-y-auto flex flex-col relative`}
            style={{
                fontFamily: pageData?.textOption?.font,
                backgroundColor: pageData?.backgroundOption?.color ? pageData?.backgroundOption?.color : pageData?.backgroundOption?.image ? 'unset' : '#ECECF2',
                backgroundRepeat: 'no-repeat',
                backgroundImage: pageData?.backgroundOption?.gradient?.length ? `linear-gradient(${pageData?.backgroundOption?.gradientAngle} ,${pageData?.backgroundOption?.gradient[0]}, ${pageData?.backgroundOption?.gradient[1]})` : pageData?.backgroundOption?.image ? `url(${(pageData?.backgroundOption?.image)})` : 'unset',
                backgroundSize: pageData?.backgroundOption?.image ? 'cover' : 'unset',
                backgroundPosition: pageData?.backgroundOption?.image ? 'center' : 'unset',
            }}>

            <div className="flex flex-col gap-3 flex-1">
                <div className={`flex flex-1 flex-col`}>
                    {
                        blocksData?.map((block, index) => {
                            return (
                                <div key={index}>
                                    {block?.blockType == 1 && (
                                        pageData?.templateNumber == 1 ? <Head1 blockData={block} designData={pageData} /> : pageData?.templateNumber == 2 ? <Head2 blockData={block} designData={pageData} /> : <div className='h-3'></div>
                                    )}
                                    {block?.blockType == 2 && <HeadingBlock blockData={block} designData={pageData} />}
                                    {block?.blockType == 3 && <ContactBlock blockData={block} designData={pageData} />}
                                    {block?.blockType == 4 && <ImageComponent blockData={block} designData={pageData} />}
                                    {block?.blockType == 5 && <SocialLinksComponent blockData={block} designData={pageData} />}
                                    {block?.blockType == 6 && <LinkComponent blockData={block} designData={pageData} />}
                                </div>
                            )
                        })
                    }
                </div>
                <div className="flex order-3 items-center justify-center mb-4">
                    <div className="aspect-square bg-white flex items-center justify-center rounded-full p-0.5 shadow-md">
                        <img src={process.env.PUBLIC_URL + "/images/icon-logo.png"} className='h-4' alt="" />
                    </div>
                </div>
            </div>

            {pageData?.floatingButtonStatus && <button className='sticky right-2 bottom-2 flex items-center gap-3 py-1.5 pe-1.5 ps-3 text-sm font-semibold ms-auto rounded-full text-white' style={{ backgroundColor: pageData?.backgroundOption?.primaryColor }}>{pageData?.floatingButtonText || 'Add to Contact'} <div className='bg-white rounded-full p-2'> <IconPlus color='black' size={20} /> </div></button>}
        </div>
    )
}

export default CardPreview;

export const Head1 = ({ designData, blockData }) => {
    return (
        <div className='h-[460px] !px-4 py-2 !mb-2 flex flex-col justify-end items-start' style={{
            backgroundImage: (blockData?.profilePhoto && blockData?.profilePhotoStatus) ? `linear-gradient(to top, ${designData?.backgroundOption?.color || '#000000'} 5%, transparent 60%) ,url(${(blockData?.profilePhoto)})` : 'unset',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
            {<p className='text-[34px] font-bold capitalize leading-[45px] !mb-2' style={{ color: designData?.textOption?.titleColor ? designData?.textOption?.titleColor : '#070707' }}>{blockData?.name ?? "Welcome"}</p>}
            {blockData?.heading && <p className='mb-1.5 text-sm font-medium' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.heading}</p>}
            {blockData?.subHeading && <p className='mb-2.5 text-md font-semibold' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.subHeading}</p>}
            {(blockData?.brandLogo && blockData?.brandLogoStatus) && <img src={blockData?.brandLogo} className='max-h-[60px] max-w-[130px]' alt="" />}
        </div>
    )
}

export const Head2 = ({ designData, blockData }) => {
    return (
        <>
            <div className='h-[360px] flex flex-col justify-end items-start relative' style={{
                backgroundImage: (blockData?.profilePhoto && blockData?.profilePhotoStatus) ? `url(${(blockData?.profilePhoto)})` : `linear-gradient(to top, ${designData?.backgroundOption?.color} 5%, transparent 60%)`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}>
                {(blockData?.brandLogo && blockData?.brandLogoStatus) && <div className='h-[100px] w-[100px] absolute bottom-14 left-6 text-center m-auto'> <img src={blockData?.brandLogo} className='w-full h-full object-contain' alt="" /></div>}

                <svg version="1.1" className="qrc_profile_5_svg" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 375 171" style={{ enableBackground: 'new 0 0 375 171' }} xmlSpace="preserve">
                    <style type="text/css" dangerouslySetInnerHTML={{ __html: `.st0{fill:${designData?.backgroundOption?.primaryColor ?? '#212121'};}.st1{fill:${designData?.backgroundOption?.color ?? 'black'};}` }} />
                    <path id="Path_1445" className="st0" d="M1.06,84.91c0,0,96.52,77.37,187.89-7.93C310.63-48.31,375.49,23.64,375.49,23.64l-0.28,127.04
                                   H0.2" />
                    <path id="Path_1446" className="st1" d="M0.2,86.33c0,0,101.34,82.28,192.71-3.03C314.6-41.98,375.2,66.77,375.2,66.77v103.91H0.2V86.33
                                   z" />
                </svg>

            </div>

            <div className='!px-4 -mt-10 !pb-3 relative' style={{ backgroundColor: designData?.backgroundOption?.color }}>
                {<p className='text-[34px] font-bold capitalize leading-[45px] !mb-2' style={{ color: designData?.textOption?.titleColor ? designData?.textOption?.titleColor : '#070707' }}>{blockData?.name ?? "Welcome"}</p>}
                {blockData?.heading && <p className='mb-1.5 text-sm font-medium' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.heading}</p>}
                {blockData?.subHeading && <p className='mb-2.5 text-md font-semibold' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.subHeading}</p>}
            </div>
        </>
    )
}

export const HeadingBlock = ({ blockData, designData }) => {
    return (
        <div className='!mx-3 px-3 py-2.5 flex items-center justify-center gap-3 !my-2' style={{
            backgroundColor: designData?.blocksOption?.background,
            borderRadius: designData?.blocksOption?.borderRadius,
            boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`,
            borderWidth: designData?.blocksOption?.border,
            borderStyle: 'solid',
            borderColor: designData?.blocksOption?.borderColor
        }}>
            <div className='w-full text-center'>
                {blockData?.title && <p className='mb-0 text-lg font-semibold capitalize' style={{ color: designData?.blocksOption?.titleColor ? designData?.blocksOption?.titleColor : '#070707' }}>{blockData?.title}</p>}
                {blockData?.description && <p className='mb-0 !mt-2 text-sm font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.description}</p>}
            </div>
        </div>


    )
}
export const ContactBlock = ({ blockData, designData }) => {
    return (
        <div className='!mx-3 px-3 py-2.5 flex items-center justify-center gap-3 relative !my-2' style={{
            backgroundColor: designData?.blocksOption?.background,
            borderRadius: designData?.blocksOption?.borderRadius,
            boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`,
            borderWidth: designData?.blocksOption?.border,
            borderStyle: 'solid',
            borderColor: designData?.blocksOption?.borderColor
        }}>

            <div className='w-full text-center'>
                <div className='flex items-center !gap-3'>
                    <div className='bg-black text-white shadow-sm p-2 rounded-full'> <IconDeviceMobile /> </div>
                    {blockData?.title && <p className='mb-0 text-lg font-semibold capitalize' style={{ color: designData?.blocksOption?.titleColor ? designData?.blocksOption?.titleColor : '#070707' }}>{blockData?.title}</p>}
                </div>
                <hr className='h-0.5 my-2 bg-white mix-blend-luminosity' />
                <div className='flex !gap-3 flex-col'>
                    {blockData?.contactNumberStatus && <div className='text-start'>
                        {blockData?.contactNumberLabel && <p className='mb-0 text-md font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.contactNumberLabel}</p>}
                        {blockData?.contactNumber && <p className='mb-0 text-xs font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.contactNumber}</p>}
                    </div>}
                    {blockData?.emailIdStatus && <div className='text-start'>
                        {blockData?.emailIdLabel && <p className='mb-0 text-md font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.emailIdLabel}</p>}
                        {blockData?.emailId && <p className='mb-0 text-xs font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.emailId}</p>}
                    </div>}
                    {blockData?.addressStatus && <div className='text-start'>
                        {blockData?.addressLabel && <p className='mb-0 text-md font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.addressLabel}</p>}
                        <p className='mb-0'>
                            {blockData?.addressLine1 && <span className='mb-0 text-xs font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.addressLine1}</span>}
                            {blockData?.addressLine2 && <span className='mb-0 text-xs font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.addressLine1 && ', '}{blockData?.addressLine2}</span>}
                        </p>
                        <p>
                            {blockData?.addressCity && <span className='mb-0 text-xs font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.addressCity}</span>}
                            {blockData?.addressState && <span className='mb-0 text-xs font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.addressCity && ', '}{blockData?.addressState}</span>}
                            {blockData?.addressZipCode && <span className='mb-0 text-xs font-medium' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.addressState && ', '}{blockData?.addressZipCode}</span>}
                        </p>
                    </div>}
                    {blockData?.addressActionButtonStatus && <button className='mt-1 mb-3 bg-blend-luminosity flex gap-1 items-center px-3 w-max py-1.5 text-xs rounded-full text-white' style={{ backgroundColor: designData?.backgroundOption?.primaryColor }}> <IconLocation size={14} /> {blockData?.addressActionButtonText} </button>}
                </div>
            </div>
        </div>


    )
}

export const ImageComponent = ({ blockData, designData }) => {
    return (
        <div className='!mx-3 grid grid-cols-2 gap-3 !my-2'>
            {blockData?.imageArray?.map((item, i) => {
                return (
                    <div className={`text-white ${blockData?.viewType == 1 ? 'col-span-2' : blockData?.viewType == 2 ? ((i % 3 === 0) ? "col-span-2" : "") : 'col-span-1'}`} key={i}>
                        <img src={item?.imageUrl} alt="" className='aspect-square w-full object-cover' style={{
                            aspectRatio: item?.aspectRatio,
                            borderRadius: designData?.blocksOption?.borderRadius,
                            boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`
                        }} />
                    </div>)
            })}
        </div>
    )
}

export const SocialLinksComponent = ({ blockData }) => {
    return (
        <div className='!mx-3 !my-2'>
            {(blockData?.status == 1 && blockData?.links?.length > 0) && <div className={`flex justify-center gap-3 flex-wrap ${blockData?.socialLinksOption?.placement == "top" ? 'order-1' : 'order-2'}`}>
                {
                    blockData?.links?.map((item) => {
                        return (
                            <a key={item.sortId} href={item.channelLink} target='_blank' rel='noopener noreferrer'>
                                <img src={item?.icon} alt="" className='h-7 object-contain' />
                            </a>
                        )
                    })
                }
            </div>}
        </div>
    )
}
export const LinkComponent = ({ blockData, designData }) => {
    return (
        <div className='!mx-3 px-4 py-2 flex items-center justify-center gap-3 !my-2' style={{
            backgroundColor: designData?.blocksOption?.background,
            borderRadius: designData?.blocksOption?.borderRadius,
            boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`,
            borderWidth: designData?.blocksOption?.border,
            borderStyle: 'solid',
            borderColor: designData?.blocksOption?.borderColor
        }}>
            {blockData?.image && <img src={blockData?.image && (blockData?.image)} alt="" className='h-12 w-12 aspect-square rounded-lg object-cover' />}
            <div className='w-full text-center'>
                {blockData?.title && <p className='mb-0 text-md font-semibold capitalize' style={{ color: designData?.blocksOption?.titleColor ? designData?.blocksOption?.titleColor : '#070707' }}>{blockData?.title}</p>}
                {blockData?.description && <p className='mb-0 text-xs font-normal' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.description}</p>}
            </div>
        </div>


    )
}
